define("Pages/Activate", [`Page`, `module`], function (Super, Self) {
	return Super.inherit({
		namespace: Self.id,
		requires: [`XHR`, `User`],
		prepare(setup) {
			const { data } = this;

			data.title = `Activate | Tixr`;
		},
		async constructor() {
			const { App, User, data } = this;
			const { trackingOptions } = data;
			const promises = [];
			let promise;

			trackingOptions.pageType = `Activate`;

			await User.get({
				require: true,
				subscribe: true,
				then: (user) => (data.user = user),
				fail: () => {
					// redirect to landing page if ever not logged in
					App.loadPath({ href: `/` });
				},
			});

			if (data.user === undefined) {
				return;
			}

			this.render();

			promise = this.create({
				namespace: `Modules/PageHeader`,
				setup: {
					name: `page-header`,
					showTixrLogo: true,
				},
			});
			promises.push(promise);

			promise = this.create({
				namespace: `Widgets/Form`,
				setup: {
					name: `form`,
					theme: `NONE`,
					inputs: {
						code: {
							type: `Textbox`,
							rules: {
								label: `Enter the code for your device`,
								isCode: true,
							},
							validation: {
								type: `String`,
								required: true,
								min_length: 6,
							},
						},
					},
					callbacks: {
						update: (value, key, inputs) => {
							if (inputs.code.validate()) {
								this.select(`[action="submit"]`).removeClass(`disabled`);
							} else {
								this.select(`[action="submit"]`).addClass(`disabled`);
							}
						},
						submit: function (values, inputs) {
							values.force = false;

							this.activate({
								request: values,
							});
						},
					},
				},
			});
			promises.push(promise);

			await Promise.all(promises);
		},
		api: {
			activate: {
				async: true,
				value(options) {
					const { request } = options;

					return this.XHR.ajax({
						type: `POST`,
						url: `/api/users/${this.data.user.id}/activations`,
						REST: true,
						data: request,
						then: () => {
							this.render({
								name: `success`,
								target: this.get(`.content.main`),
							});
						},
						fail: (reason) => {
							try {
								const error = JSON.parse(reason.responseText);
								const { docType, code, message } = error;

								if (docType === `STANDARD_ERROR` && (code === 6003 || code === 6007)) {
									return this.App.askUser({
										message,
										yesLabel: `Yes`,
										noLabel: `No`,
										then: (yes) => {
											if (yes) {
												request.force = true;

												return this.activate({
													request,
												});
											}

											this.render({
												name: `decline`,
												target: this.get(`.content.main`),
											});
										},
									});
								}
							} catch (err) {
								throw reason; // throw original reason if there was a parsing error
							}

							throw reason; // Re-throw if not handled
						},
					});
				},
			},
		},
	});
});

define("Pages/Activate.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Pages/Activate/decline"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h1>Activation Cancelled</h1> <h3>Enjoy watching your videos on your existing registered device.</h3>";
},"useData":true});

this["Templates"]["Pages/Activate/main"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<header class=\"head\"> <div name=\"page-header\"></div> <div class=\"scroll-head-background\"></div> </header> <main class=\"body\"> <div class=\"background\"> <div class=\"image\"></div> </div> <div class=\"content main vp-min-height\"> <h1>Activate Device</h1> <div name=\"form\"> <div name=\"code\"></div> <a href=\"#\" class=\"button\" action=\"submit\" theme=\"BLUE\"> <p>Activate</p> </a> </div> </div> </main>";
},"useData":true});

this["Templates"]["Pages/Activate/success"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h1>You're done!</h1> <h3>Your device will activate shortly.</h3>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=Activate.js.map